import "./about.css"

export default function About() {
  return (
    <div className="container">
      <section className="section" id="about">
      <div className="title">About us</div>
        <div className="subtitle">What is GasGoo 🔥 ?</div>
        <div className="container">
            <p className="description">
            <b>GasGoo</b> is an innovative web app that lets users easily find the <em>nearest petrol stations</em> where to <em>refill their vehicles</em> with the needed fuel.
            The app allows you to avoid queues and time wasted with a <em>faster payment system</em> that enables the user to purchase products and fuels inside the applications itself.
            Rather than then the usual utilities there’s gone to be an <em>‘ask for help’</em> section, the possibility to <em>compare the fuel prices</em> in several parts of the country and the access to emergency informations and useful phone numbers, as well as <em>checking how busy a gas station is</em> and what <em>services</em> it offers in particular
            .</p>

        </div>

    </section>
    </div>
  );
}


